import { Link } from "react-router-dom";
import { EntityMarkdown } from "./entity";
import { DME, RenderToSetting, useDevice, useEditorStore } from "dmeditor";
import { useEffect, useState } from "react";
import showdown from "showdown";

showdown.setFlavor("github");
const converter = new showdown.Converter();

const Markdown = (props: DME.WidgetRenderProps<EntityMarkdown>) => {
  const {
    blockNode: { data },
  } = props;

  const { updateSelectedBlock } = useEditorStore();

  const [value, setValue] = useState(data.markdownData);

  useEffect(() => {
    updateSelectedBlock((data: EntityMarkdown) => {
      data.markdownData = value;
    });
  }, [value]);

  return (
    <div className="markdown-body" data-theme={"dark"}>
      {props.active && (
        <RenderToSetting>
          <textarea
            onChange={(e) => {
              setValue(e.target.value);
            }}
            style={{
              width: "100%",
              border: "1px solid #cccccc",
              fontFamily:
                "source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace",
              padding: 5,
              fontSize: 14,
              minHeight: 400,
            }}
          >
            {value}
          </textarea>
        </RenderToSetting>
      )}
      {value && (
        <div
          dangerouslySetInnerHTML={{ __html: converter.makeHtml(value) }}
        ></div>
      )}
      {!value && props.mode === "edit" && (
        <div style={{ padding: 10, color: "#999999", fontStyle: "italic" }}>
          Please write markdown on side area.
        </div>
      )}
    </div>
  );
};

export { Markdown };
